module.exports = __webpack_public_path__ + "img/pr-2.d8c1086d.png";